const bookViewColumnDefs = [
  {
    headerName: 'Code',
    field: 'bookCode',
    width: 140,
    cellRenderer: 'agGroupCellRenderer',
  },
  { headerName: 'Desc', field: 'bookDesc', width: 200 },
  { headerName: 'FundBookCode', field: 'fundBookCode', width: 160 },
  { headerName: 'Ownedby', field: 'fundCode', width: 140 },
  { headerName: 'ManagedBy', field: 'managerName', width: 160 },
  {
    headerName: 'IsPlatform',
    field: 'isPlatform',
    width: 90,
    cellDataType: 'boolean',
  },
  { headerName: 'Strategy', field: 'strategy', width: 120 },
  { headerName: 'Location', field: 'location', width: 120 },
  {
    headerName: 'EnableTxnStrategy',
    field: 'enableTxnStrategy',
    cellDataType: 'boolean',
    width: 90,
  },
  { headerName: 'LastModifiedBy', field: 'lastModifiedBy', width: 140 },
  { headerName: 'LastModifiedOn', field: 'lastModifiedOn', width: 160 },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      fn: () => {},
    },
  },
]

const detailColumnDefs = [
  { field: 'fundCode', headerName: 'Fund' },
  { field: 'bookCode', headerName: 'Book' },
  { field: 'fundBookCode', headerName: 'FundBook' },
]

export { bookViewColumnDefs, detailColumnDefs }
